import React from 'react';
import styled from 'styled-components';
import { fontSize } from '../utils/style/font';
import space from '../utils/style/space';

const Container = styled.div`
  padding-top: ${space.xxl}px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const P = styled.p`
  width: 100%;
  max-width: 320px;
  font-size: ${fontSize.l}px;
  text-align: left;
`;

const LabelContainer: React.FC<React.Props<{}>> = ({ children }) => (
  <Container>
    <P>{children}</P>
  </Container>
);

export default LabelContainer;
